import { render, staticRenderFns } from "./verifyList.vue?vue&type=template&id=4b96532a&scoped=true&"
import script from "./verifyList.vue?vue&type=script&lang=js&"
export * from "./verifyList.vue?vue&type=script&lang=js&"
import style0 from "./verifyList.vue?vue&type=style&index=0&id=4b96532a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b96532a",
  null
  
)

export default component.exports